import { tKey } from "@/core/i18n";
import { Cpu, Database, Rocket, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StartupScreen, type StartupStep } from "../StartupScreen";

export interface TrainingStartupScreenProps {
  modelName?: string;
  /** ISO timestamp the training job was dispatched — see StartupScreen. */
  startedAt?: string | null;
}

const STEPS: StartupStep[] = [
  {
    key: "provision",
    label: tKey("model:trainingStartup.steps.provision"),
    icon: Cpu,
    estimatedMs: 25_000,
  },
  {
    key: "dataset",
    label: tKey("model:trainingStartup.steps.dataset"),
    icon: Database,
    estimatedMs: 30_000,
  },
  {
    key: "model",
    label: tKey("model:trainingStartup.steps.model"),
    icon: Sparkles,
    estimatedMs: 25_000,
  },
  {
    key: "launch",
    label: tKey("model:trainingStartup.steps.launch"),
    icon: Rocket,
    estimatedMs: 40_000,
  },
];

export const TrainingStartupScreen = ({ modelName, startedAt }: TrainingStartupScreenProps) => {
  const { t } = useTranslation(["model", "common"]);
  return (
    <StartupScreen
      icon={Rocket}
      heading={
        modelName
          ? t("trainingStartup.heading", { name: modelName })
          : t("trainingStartup.headingNoName")
      }
      subtitle={t("trainingStartup.subtitle")}
      steps={STEPS}
      startedAt={startedAt}
      footerNote={t("trainingStartup.footerNote")}
    />
  );
};
